import React, { useState, useEffect } from 'react';
import demoCar from '../../assets/images/parked.png';
import NextArrow from '../../assets/images/next.svg';
import { useSelector } from 'react-redux';
import {formatDateNew, addMonths} from '../../utils/redableDateTime.js';
import iconLiveView from '../../assets/images/live.svg';
import { Get, Post } from '../../Api/ApiMethods.js';
import { 
  getMybookinListUrl, 
  cancelBookingUrl 
} from '../../Routes/ApiRoutes';
import CancelBooking from './CancelBooking';
import { toast } from 'react-toastify';
import CircularLoader from '../../utils/Loaders/CircularLoader';
import { NavLink } from 'react-router-dom';


export default function MyBooking() {
    const token = useSelector((state) => state.auth.isSignedIn);
    const [mybooks, setMyBooking] = useState([]);
    const [cancelBook, setCancelBook] = useState(false);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
      fetchMyBookingList();
    }, []);

    const fetchMyBookingList = () => {
      setLoader(true);
      try {
          Get(getMybookinListUrl, token, 'pageNo=1&pageSize=50')
          .then(response => {
            setLoader(false);
            setMyBooking(response.data.rows);
          })
          .catch(error => {
            setLoader(false);
              toast.error(error.error)
              console.log(error);
          })
        }catch (error) {
          setLoader(false);
          toast.error(error.error)
          console.log(error);
      }
    }

    const handleCancelBooking = (d) => {
      setLoader(true);
      let sendData = {
          "booking_id":d.id
      }
      try {
          Post(cancelBookingUrl, token, sendData)
          .then(res => {
              if(res.status === 200){
                toast.success(res.message);
                fetchMyBookingList();
                setCancelBook(false);
              }
          })
          .catch(error => {
              toast.error(error.error);
              setLoader(false);
              setCancelBook(false);
              console.log(error);
          })
        }catch (error) {
          toast.error(error.error);
          setLoader(false);
          console.log(error);
          setCancelBook(false);
      }
    }

    return (
      <>
      {loader && <CircularLoader />}
      {cancelBook && <CancelBooking handleCancelBooking={handleCancelBooking}
      item={cancelBook} setCancelBook={setCancelBook} />}                  
      <section className="mybooking-details-wrapper">
        <div className="container">
          <div className="my-booking-details">
          <div className="row no-gutters">
              {mybooks.length > 0 ? 
                <div className="col-md-4 col-sm-12 col-12 padding-rt">
                  <div className='sideBar no-padding'>
                  {mybooks.map((item) => {
                      return(
                        <div key={item.id} className="Covered-parking">
                          <img className="img-fluid" src={item.slot.slot_image ? item.slot.slot_image : demoCar} />
                          <div className="transport-details">
                          <span className='bookinDate'>{formatDateNew(item.booking_date)}</span>
                            <p>Space: <span>{item.slot.slotNumber}</span></p>
                            <p>Slot Id: <span>{item.slot.id}</span></p>
                            <p>Type : <span>{item.slot.parking_type.type}</span></p>
                            <p>Price : <span>{item.slot.price}</span></p>
                            <p>Dimensions: <span>{item.slot.parking_dimension.dimension} ft</span></p>
                            <p>Validity: <span>{addMonths(new Date(item.booking_date), 1)}</span></p>
                            <p>Description: <span className='description'>Beautiful lush green environment with shed to protect your vehicle from direct sunlight. Beautiful lush green environment with shed to protect your vehicle from direct sunlight{item.slot.description}</span></p>
                            {/* <div className='liveView'>Live view of parking space <img src={iconLiveView}/></div> */}
                              <div className="buttons-wrapper">
                                  <div className="comman-btn">
                                  <NavLink to="/maintainance" className="nav-link">
                                  <button >Generate access code for vendors</button>
                                    </NavLink>
                                  </div>
                                  <div className="Cancel-booking">
                                    <button onClick={() => setCancelBook(item)}>Cancel booking</button>
                                  </div>
                              </div>
                          </div>
                          </div>
                      )
                  })}
                </div>
              </div>
              : 
                <div className="col-12 padding-rt">
                  <div style={{textAlign:'center', padding:'200px 0'}}>
                    <p>No booking found!</p>
                  </div>
                </div>
              }
                {/* <div className="col-md-8 col-sm-12 col-12 padding-rt padding-lt">
                    <div className="Past-booking">
                      <h3>Past booking</h3>

                      <div className="row no-gutters">
                          <div className="col-6">
                            <div className="booking-info-wrapper">
                              <div className="booking-date">
                                <p> Booking 101 <span>22 jan 2021</span></p>
                              </div>
                              <div className="space-details">
                                <div className="Space-no">
                                  <p>Space no: <span>111</span></p>
                                  <p>Dimensions: <span>44x24 ft</span></p>
                                </div>
                                <div className="next-img">
                                  <img src={NextArrow} />
                                </div>
                              </div>
                          </div>
                        </div>
                          <div className="col-6">
                            <div className="booking-info-wrapper">
                              <div className="booking-date">
                                <p> Booking 101 <span>22 jan 2021</span></p>
                              </div>
                              <div className="space-details">
                                <div className="Space-no">
                                  <p>Space no: <span>111</span></p>
                                  <p>Dimensions: <span>44x24 ft</span></p>
                                </div>
                                <div className="next-img">
                                  <img src={NextArrow} />
                                </div>
                              </div>
                          </div>
                        </div>
                          <div className="col-6">
                            <div className="booking-info-wrapper">
                              <div className="booking-date">
                                <p> Booking 101 <span>22 jan 2021</span></p>
                              </div>
                              <div className="space-details">
                                <div className="Space-no">
                                  <p>Space no: <span>111</span></p>
                                  <p>Dimensions: <span>44x24 ft</span></p>
                                </div>
                                <div className="next-img">
                                  <img src={NextArrow} />
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div> */}
              </div>
          </div>
        </div>
      </section> 
      </>
    )
}
